import { render, staticRenderFns } from "./VueShowMoreText.vue?vue&type=template&id=45f35f38&scoped=true&"
import script from "./VueShowMoreText.vue?vue&type=script&lang=js&"
export * from "./VueShowMoreText.vue?vue&type=script&lang=js&"
import style0 from "./VueShowMoreText.vue?vue&type=style&index=0&id=45f35f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f35f38",
  null
  
)

export default component.exports